import { ConnectedUserModel } from './connected-user-model';

export class UndertakenActionModel {
  actionDate: Date;
  kind: string;
  user: ConnectedUserModel;
  action: string;
}
